import React, { useEffect, useState } from 'react';
import Layout from '../Layout/Layout';
import { getSpotlightYears, getSpotlightMonths, getSpotlightsByMonth } from './utilities/ApiCalls';

const BG_COLOR = '#0f1817';

const SpotlightDetails = () => {
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [spotlights, setSpotlights] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);
  const [selectedMonth, setSelectedMonth] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [spotlightIndex, setSpotlightIndex] = useState(0);

  useEffect(() => {
    setLoading(true);
    getSpotlightYears()
      .then(res => {
        if (res.status === 'success') {
          setYears(res.data);
        } else {
          setError('Failed to fetch years');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch years');
        setLoading(false);
      });
  }, []);

  const handleYearClick = (year) => {
    setSelectedYear(year);
    setSelectedMonth(null);
    setSpotlights([]);
    setSpotlightIndex(0);
    setLoading(true);
    getSpotlightMonths(year)
      .then(res => {
        if (res.status === 'success') {
          setMonths(res.data);
        } else {
          setError('Failed to fetch months');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch months');
        setLoading(false);
      });
  };

  const handleMonthClick = (month) => {
    setSelectedMonth(month);
    setSpotlightIndex(0);
    setLoading(true);
    getSpotlightsByMonth(selectedYear, month)
      .then(res => {
        if (res.status === 'success') {
          setSpotlights(res.data);
        } else {
          setError('Failed to fetch spotlights');
        }
        setLoading(false);
      })
      .catch(() => {
        setError('Failed to fetch spotlights');
        setLoading(false);
      });
  };

  const handleBack = () => {
    if (selectedMonth) {
      setSelectedMonth(null);
      setSpotlights([]);
      setSpotlightIndex(0);
    } else if (selectedYear) {
      setSelectedYear(null);
      setMonths([]);
    }
  };

  const handlePrevSpotlight = () => {
    setSpotlightIndex((prev) => (prev > 0 ? prev - 1 : spotlights.length - 1));
  };
  const handleNextSpotlight = () => {
    setSpotlightIndex((prev) => (prev < spotlights.length - 1 ? prev + 1 : 0));
  };

  const getCardStyle = (isMobile) => ({
    border: '1px solid #fff',
    borderRadius: 12,
    padding: isMobile ? 12 : 24,
    width: isMobile ? '100%' : 350,
    background: '#263a38',
    color: '#fff',
    boxShadow: '0 2px 16px rgba(0,0,0,0.12)',
    margin: isMobile ? '0 auto' : undefined,
  });

  return (
    <Layout>
      <div
        style={{
          minHeight: '100vh',
          background: BG_COLOR,
          color: '#fff',
          padding: 0,
          margin: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        
        <div style={{ flex: 1, width: '100%', maxWidth: 1300, margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'flex-start', justifyContent: 'flex-start', paddingTop: 24 }}>
          {error && <div style={{ color: 'red', marginBottom: 16, textAlign: 'center', width: '100%' }}>{error}</div>}
          {loading ? (
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 200 }}>
              <div>Loading...</div>
            </div>
          ) : (
            <>
            {/* Header Bar */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: BG_COLOR,
          padding: '24px 24px 0 45px',
          minHeight: 70,
        }}>
          <div style={{ fontSize: 28, fontWeight: 700, color: '#fff' }}>
            {selectedMonth && selectedYear ? (
              <>
                Spotlights - {selectedYear} / {selectedMonth}
                <button
                  onClick={handleBack}
                  style={{
                    marginLeft: 16,
                    background: '#6c757d',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    padding: '4px 14px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    fontSize: 16,
                  }}
                >
                  Back
                </button>
              </>
            ) : selectedYear ? (
              <>
                Months - {selectedYear}
                <button
                  onClick={handleBack}
                  style={{
                    marginLeft: 16,
                    background: '#6c757d',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 6,
                    padding: '4px 14px',
                    fontWeight: 500,
                    cursor: 'pointer',
                    fontSize: 16,
                  }}
                >
                  Back
                </button>
              </>
            ) : (
              'Spotlight Archive'
            )}
          </div>
        </div>
              {/* Years */}
              {!selectedYear && !selectedMonth && (
                <div style={{ marginBottom: 16, width: '100%', margin: '0 45px', marginTop: '20px' }}>
                  {/* <h3 style={{ color: '#fff', marginBottom: 16 }}>Years</h3> */}
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {years.map((y) => (
                      <button
                        key={y.year}
                        style={{
                          padding: '12px 28px',
                          background: '#fff',
                          color: BG_COLOR,
                          border: 'none',
                          borderRadius: 8,
                          cursor: 'pointer',
                          fontWeight: 700,
                          fontSize: 20,
                        }}
                        onClick={() => handleYearClick(y.year)}
                      >
                        {y.year} ({y.count})
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {/* Months */}
              {selectedYear && !selectedMonth && (
                <div style={{ marginBottom: 16, width: '100%', margin: '0 45px', marginTop: '20px' }}>
                  {/* <h3 style={{ color: '#fff', marginBottom: 16 }}>Months in {selectedYear}</h3> */}
                  <div style={{ display: 'flex', gap: 12, flexWrap: 'wrap' }}>
                    {months.map((m) => (
                      <button
                        key={m.month}
                        style={{
                          padding: '12px 28px',
                          background: '#fff',
                          color: BG_COLOR,
                          border: 'none',
                          borderRadius: 8,
                          cursor: 'pointer',
                          fontWeight: 700,
                          fontSize: 20,
                        }}
                        onClick={() => handleMonthClick(m.month)}
                      >
                        {m.month} ({m.count})
                      </button>
                    ))}
                  </div>
                </div>
              )}
              {/* Spotlights */}
              {selectedMonth && (
                <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '20px' }}>
                  {spotlights.length === 0 && <div style={{ color: '#fff' }}>No spotlights found.</div>}
                  {spotlights.length > 0 && (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 24, marginTop: 32 }}>
                        {spotlights.length > 1 && (
                          <button
                            onClick={handlePrevSpotlight}
                            style={{
                              background: '#fff',
                              color: BG_COLOR,
                              border: 'none',
                              borderRadius: 8,
                              padding: '8px 18px',
                              fontWeight: 700,
                              fontSize: 18,
                              cursor: 'pointer',
                            }}
                            aria-label="Previous Spotlight"
                          >
                            &#8592;
                          </button>
                        )}
                        <div style={{ border: '1px solid #fff', borderRadius: 12, padding: 24, width: 350, background: '#263a38', color: '#fff', boxShadow: '0 2px 16px rgba(0,0,0,0.12)' }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                            <img src={spotlights[spotlightIndex].imageUrl} alt={spotlights[spotlightIndex].author} style={{ width: 70, height: 70, borderRadius: '50%', objectFit: 'cover', border: '2px solid #fff' }} />
                            <div>
                              <div style={{ fontWeight: 'bold', fontSize: 20 }}>{spotlights[spotlightIndex].author}</div>
                              <div style={{ fontSize: 13, color: '#b0b0b0' }}>{spotlights[spotlightIndex].month} {spotlights[spotlightIndex].year}</div>
                            </div>
                          </div>
                          <div style={{ marginTop: 18 }}>
                            {spotlights[spotlightIndex].quotes.map((q) => (
                              <div key={q._id} style={{ marginBottom: 12, padding: 12, background: '#263a38', borderRadius: 8, color: '#fff' }}>
                                <div style={{ fontStyle: 'italic', color: '#fff', fontSize: 16 }}>&ldquo;{q.quote}&rdquo;</div>
                                <div style={{ fontSize: 14, color: '#b0b0b0' }}>~ {q.title}</div>
                                <a href={q.storyLink} target="_blank" rel="noopener noreferrer" style={{ fontSize: 13, color: '#fff', textDecoration: 'underline' }}>Read Story</a>
                              </div>
                            ))}
                          </div>
                        </div>
                        {spotlights.length > 1 && (
                          <button
                            onClick={handleNextSpotlight}
                            style={{
                              background: '#fff',
                              color: BG_COLOR,
                              border: 'none',
                              borderRadius: 8,
                              padding: '8px 18px',
                              fontWeight: 700,
                              fontSize: 18,
                              cursor: 'pointer',
                            }}
                            aria-label="Next Spotlight"
                          >
                            &#8594;
                          </button>
                        )}
                      </div>
                      {spotlights.length > 1 && (
                        <div style={{ marginTop: 16, color: '#fff', fontSize: 15 }}>
                          {spotlightIndex + 1} of {spotlights.length}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default SpotlightDetails;
